import { createHomeQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useHomeQuery = createHomeQuery(HTTP_CONFIG.API.Optimizely.url)
